import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CMFNumber = ({data}:any) =>{
  const [cmfNumber, setCmfNumber] = useState<string>();
  const [noDataFound,setNoDataFound] = useState<boolean>();
  const { t } = useTranslation();

  useEffect(()=>{
    if (data === null || (data && data.shipCmf === null)){
      setNoDataFound(true);
    }
    if (data && data.shipCmf){
      setCmfNumber(data.shipCmf);
    }
  },[data]);

  return (
    <div style={{marginTop:'20px',marginLeft:'15px'}}>
      { noDataFound && t('meetmycdkteam.cmfNotFound')}
      { cmfNumber &&
        <div>{t('meetmycdkteam.cmfNumber')} : <span style={{fontWeight:700}}>{cmfNumber}</span></div>
    }
    </div>
  )
}